import React from 'react';
import { CatList } from '@blocks-react/components/List';
import { v4 as uuid } from 'uuid';
import { MyEquipmentListProps, equipmentListProps } from '../types';
import { EQUIPMENT_LIST_LIMIT } from '../constants';
import { MyEquipmentListItem } from './my-equipment-list-item';

export const MyEquipmentList = ({
  list,
  onEqpuipmentSelect,
  searchTerm,
  selectedEquipment,
  limit = EQUIPMENT_LIST_LIMIT,
  children
}: MyEquipmentListProps) => {
  return (
    <CatList>
      {list.slice(0, limit).map((item: equipmentListProps) => (
        <React.Fragment key={uuid()}>
          <MyEquipmentListItem
            item={item}
            selectedEquipment={selectedEquipment}
            onEquipmentSelect={onEqpuipmentSelect}
            searchTerm={searchTerm}
            elementKey={uuid()}
          >
            {children}
          </MyEquipmentListItem>
        </React.Fragment>
      ))}
    </CatList>
  );
};
